export enum CpCellType {
  CONTROL_SCALE = 'CONTROL_SCALE',
  CONTROL_HOLDOUT = 'CONTROL_HOLDOUT',
  BAU = 'BAU'
}
